import { createRouter, createWebHistory } from 'vue-router'
import StockSummary from '../views/StockSummary.vue'
import Login from '../views/Login.vue'
import { isLoggedIn } from '../api/auth'

const routes = [
  {
    path: '/',
    redirect: '/summary'
  },
  {
    path: '/summary',
    name: 'StockSummary',
    component: StockSummary,
    meta: { requiresAuth: false, keepAlive: true }
  },
  {
    path: '/article/:id',
    name: 'ArticleDetail',
    component: () => import('../views/ArticleDetail.vue'),
    meta: { requiresAuth: false },
    beforeEnter: (to, from, next) => {
      if (to.params.id) {
        next();
      } else {
        next('/summary');
      }
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/summary'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Global auth guard
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isLoggedIn()) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
